<template>
  <div>
    <div class="row" v-if="loading">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="!loading">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                {{ detail.address_street.toUpperCase() }},
                {{ detail.state.name.toUpperCase() }},
                {{ detail.city.toUpperCase() }}, {{ detail.zip_code }}
              </h4>
              <form
                @submit.prevent="onSubmit"
                novalidate
                enctype="multipart/form-data"
                :class="
                  submitted
                    ? 'needs-validation was-validated'
                    : 'needs-validation'
                "
              >
                <input
                  type="hidden"
                  name="csrfmiddlewaretoken"
                  value="dpt5PoSm5THG13rPVx4lOghnlQMUbjdB6ojtCe3PkhumD1XrC0T9AzotH1GrRlGc"
                />

                <!-- Start Row -->
                <div class="row">
                  <!-- Start Col -->
                  <div class="col-lg-6">
                    <label for="organization_id">Organization*</label>
                    <v-select
                      v-model="$v.organization.$model"
                      :options="organizationList"
                    ></v-select>
                    <div
                      v-if="submitted && !$v.organization.required"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>
                  <!-- End Col -->

                  <!-- Start Col -->
                  <div class="col-lg-6">
                    <label for="">Address Type</label>
                    <ul id="address_type_id" class="checkbox inline">
                      <li>
                        <label for="address_type_id_0"
                          ><input
                            type="checkbox"
                            name="address_type"
                            value="service_location"
                            id="address_type_id_0"
                            class="checkbox inline"
                            v-model.trim="$v.address_type.$model"
                          />
                          Service Location</label
                        >
                      </li>
                      <li>
                        <label for="address_type_id_1"
                          ><input
                            type="checkbox"
                            name="address_type"
                            value="billing_address"
                            id="address_type_id_1"
                            class="checkbox inline"
                            v-model.trim="$v.address_type.$model"
                          />
                          Billing Address</label
                        >
                      </li>
                      <li>
                        <label for="address_type_id_2"
                          ><input
                            type="checkbox"
                            name="address_type"
                            value="headquarters"
                            id="address_type_id_2"
                            class="checkbox inline"
                            v-model.trim="$v.address_type.$model"
                          />
                          Headquarters</label
                        >
                      </li>
                    </ul>
                    <div
                      v-if="submitted && !$v.address_type.required"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>
                  <!-- End Col -->
                </div>
                <!-- End Row -->

                <p></p>

                <!-- Start Button -->
                <div>
                  <button
                    class="btn btn-success"
                    :disabled="loadingAction"
                    type="submit"
                  >
                    Save
                  </button>
                  <button type="button" class="btn btn-light waves-effect"  @click="$router.go(-1)">
                    Cancel
                  </button>
                </div>
                <!-- End Button -->
              </form>
              <!-- End Form -->
            </div>
            <!-- End Card Body -->
          </div>
          <!-- End Card -->
        </div>
        <!-- End Col -->
      </div>
    </template>
  </div>
</template>

<script>
import { organizationsService } from '../services/organizations.service'
import { addressesService } from '../services/addresses.service'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import { router } from '../router'

export default {
  name: 'AddAddressesOrg',
  components: {},
  data () {
    return {
      organizationList: [],
      address_type: [],
      submitted: false,
      loading: true,
      loadingAction: false,
      error: '',
      detail: {}
    }
  },
  validations: {
    organization: { required },
    address_type: { required }
  },
  computed: {},
  created () {
    if (!this.$route.params.id || this.$route.params.id === '') {
      router.push('/mpg/addresses/')
    }

    organizationsService
      .getData({ q: '', limit: '999999999', ordering: '', offset: 0, expands: '' })
      .then((rs) => {
        this.organizationList = rs.results.map((e) => {
          e.label = e.name
          e.code = e.organization_id
          return e
        })

        addressesService.getDataById(this.$route.params.id).then((rs) => {
          this.detail = rs
          this.loading = false
          this.organizationList = this.organizationList.filter((e) => {
            return !this.detail.organizations_addresses.find(
              (g) => g.organization.organization_id === e.organization_id
            )
          })
        })
      })
  },
  methods: {
    moment,
    onSubmit () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.loadingAction = true
      const payload = {
        organization: this.organization.code,
        address_type: this.address_type,
        address: this.$route.params.id,
        property_status: 'active'
      }
      addressesService.addOrgToAddress(payload).then(
        (rs) => {
          this.$nextTick(() => {
            router.push(
              `/mpg/addresses/${this.$route.params.id}/organizations/`
            )
          })
        },
        (error) => {
          this.error = error
          this.loadingAction = false
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/AddAddressesOrg.vue